import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { isAuthenticated as IsAuthenticatedQuery } from './types/isAuthenticated';

export const isAuthenticatedQuery = gql`
  query isAuthenticated {
    isAuthenticated: isAuthenticatedV2
  }
`;

export const useIsAuthenticated = () => {
  const { data, error, loading } = useQuery<IsAuthenticatedQuery>(
    isAuthenticatedQuery
  );

  return {
    error: error ? 'There was an issue loading data.' : undefined,
    isLoading: loading,
    isAuthenticated: Boolean(data?.isAuthenticated),
  };
};
